/**
 * NavigationController
 * 
 * @Author: Focci
 * @Date: 2023-07-13 17:43:09
 * @Last Modified by: Focci
 * @Last Modified time: 2023-07-13 17:43:09
 */

import PropTypes from 'prop-types'
import clsx from 'clsx'
import AddIcon from '@mui/icons-material/Add'
import RemoveIcon from '@mui/icons-material/Remove'
import { useCallback, useEffect, useState } from 'react'
import { useMap } from 'react-map-gl'
import ControllerWrapper from './ControllerWrapper'

export default function NavigationController({
  small = false,
  vertical = false,
  className,
}) {
  const { current: mapbox } = useMap()
  const [zoom, setZoom] = useState(0)
  const [zoomLimit, setZoomLimit] = useState([])
  const iconSx = { fontSize: small ? '1rem' : '1.5rem' }

  const handleChagneZoom = useCallback(
    () => setZoom(mapbox.getZoom()), 
    [mapbox]
  )

  useEffect(() => {
    const min = mapbox.getMinZoom()
    const max = mapbox.getMaxZoom()

    setZoomLimit([min < 1 ? 1 : min, max])
    handleChagneZoom()
    mapbox.on('zoomend', handleChagneZoom)

    return () => mapbox.off('zoomend', handleChagneZoom)
  }, [handleChagneZoom, mapbox])

  return (
    <div className={clsx(['shadow-large rounded-md flex', vertical && 'flex-col'])}>
      <ControllerWrapper 
        className={clsx([vertical ? 'rounded-t-md' : 'rounded-l-md', className])}
        small={small}
        disabled={zoom >= zoomLimit[1]}
        onClick={() => mapbox.zoomTo(zoom + 1)}
      >
        <AddIcon sx={iconSx} />
      </ControllerWrapper>
      <ControllerWrapper 
        className={clsx([
          className,
          vertical
            ? 'rounded-b-md border-t border-t-solid border-t-gray-100'
            : 'rounded-r-md border-l border-l-solid border-l-gray-100'
        ])}
        small={small}
        disabled={zoom <= zoomLimit[0]}
        onClick={() => mapbox.zoomTo(zoom - 1)}
      >
        <RemoveIcon sx={iconSx} />
      </ControllerWrapper>
    </div>
  )
}

NavigationController.propTypes = {
  small: PropTypes.bool,
}
